/** Language switcher for Explorer chrome. */

import clsx from 'clsx';

import { useLocale } from '~/i18n/LocaleContext';
import type { LocaleCode } from '~/i18n/catalog';

export function CpcLanguageSelect({
	className,
	compact = false,
}: {
	className?: string;
	compact?: boolean;
}) {
	const { locale, setLocale, t, codes, labels } = useLocale();

	return (
		<label className={clsx('flex flex-col gap-1', className)}>
			{!compact ? (
				<span className="text-[11px] font-medium uppercase tracking-wide text-[#64748b]">
					{t('common.language')}
				</span>
			) : null}
			<select
				className={clsx(
					'rounded-lg border border-[#1E293B] bg-[#0B1220] px-2.5 py-1.5 text-sm text-[#e2e8f0]',
					'focus:border-[#38BDF8]/50 focus:outline-none focus:ring-1 focus:ring-[#38BDF8]/40',
					compact && 'w-full',
				)}
				value={locale}
				aria-label={t('common.language')}
				onChange={(e) => setLocale(e.target.value as LocaleCode)}
			>
				{codes.map((code) => (
					<option key={code} value={code}>
						{labels[code]}
					</option>
				))}
			</select>
		</label>
	);
}
